<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useTenantStore } from '@/store';
import General from './General.vue';
import { LocationForm } from '@/components/Forms';
import { storeToRefs } from 'pinia';
import { LocationFormInterface, TenantPayloadInterface } from '@/types';

const tenantStore = useTenantStore();
const toast = useToast();
const { tenant } = storeToRefs(tenantStore);

const onSaveGeneral = async (name: string) => {
  if (tenant?.value) {
    tenant.value.name = name;
    await tenantStore.updateTenant(payload.value as TenantPayloadInterface);
    doToast();
  }
};

const onSaveLocation = async (location: LocationFormInterface) => {
  if (tenant?.value?.location) tenant.value.location = location;
  await tenantStore.updateTenantLocation(payload.value as TenantPayloadInterface);
  doToast();
};

/**
 * Define the request update payload.
 */
const payload = computed(() => {
  return {
    tenant: tenant?.value,
    location: tenant?.value?.location,
  };
});

/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'Tenant information has been saved',
    life: 3000,
  });
};
</script>

<template>
  <div class="w-full flex flex-row">
    <div class="md:col-6 col-12">
      <General @save="onSaveGeneral" />
    </div>
    <div class="md:col-6 col-12">
      <LocationForm
        v-if="tenant?.location"
        :data="(tenant.location as LocationFormInterface)"
        :permission-to-edit="true"
        :is-organization="false"
        :is-tenant="true"
        class="location"
        :loading="tenantStore.loading"
        @save="onSaveLocation"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.general,
.location {
  min-height: 562px;
}

.general {
  border: 3px solid white;
}
</style>
